import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BrokerService } from 'src/app/service/broker-service/broker.service';
import { ParserService } from 'src/app/component/broker-parser/planner-service/parser-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { TutorialService } from 'src/app/service/tutorials/tutorial.service';

@Component({
  selector: 'app-tutorial-list',
  templateUrl: './tutorial-list.component.html',
  styleUrls: ['./tutorial-list.component.css']
})
export class TutorialListComponent implements OnInit, OnDestroy {

  search: string = '';
  selectedStatus: boolean = true;
  currentPage = 1;
  totalPages = 0;
  totalResults = 0;
  tutorialsList: any[] = [];
  filtertutorialsList: any[] = [];
  tutorialModalObj:any;
  user: any;
  type: string = 'all';

  constructor(
    private brokerService: BrokerService,
    private parserService: ParserService,
    private sharedDataService: SharedDataService,
    private tutorialService : TutorialService
  ) {}

  ngOnInit(): void {
   this.getTutorials(this.currentPage)
  }

  getTutorials(page: number) {
    const queryparams: any = {
      page,
      limit: 9999,
      isActive: this.selectedStatus,
      audience: 'company',
    };

    if (this.type && this.type !== 'all') {
      queryparams.type = this.type;
    }

    if (this.search.trim()) {
      queryparams.search = this.search.trim();
    }

    this.tutorialService.getTutorials(queryparams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (res: any) => {
          this.tutorialsList = res.results || [];
          this.filtertutorialsList = res.results || [];
          this.totalPages = res.totalPages || 0;
          this.totalResults = res.totalResults || 0;
        },
        (error) => {
          this.clearTutorials();
        }
      );
  }

  clearTutorials() {
    this.tutorialsList = [];
    this.filtertutorialsList = [];
    this.totalPages = 0;
    this.totalResults = 0;
  }

  onSelectStatus() {
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  onSelectType() {
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  ngOnDestroy(): void {}
}
